// Error messages
export const API_ERRORS = {
    GENERIC: 'Something went wrong. Please try again later.',
    CONNECTION: 'Unable to connect to the server. Please check your internet connection.',
    TIMEOUT: 'The request timed out. Please try again.',
    UNAUTHORIZED: 'You are not authorized to perform this action.',
    NOT_FOUND: 'The requested resource was not found.',
    VALIDATION: 'Please check your input and try again.',
  };
  
  export const AUTH_ERRORS = {
    INVALID_CREDENTIALS: 'Invalid email or password.',
    ACCOUNT_LOCKED: 'Your account has been locked. Please contact support.',
    SESSION_EXPIRED: 'Your session has expired. Please log in again.',
    WEAK_PASSWORD: 'Password does not meet the required criteria.',
    EMAIL_IN_USE: 'This email is already registered.',
  };
  
  export const FORM_ERRORS = {
    REQUIRED: 'This field is required.',
    INVALID_EMAIL: 'Please enter a valid email address.',
    PASSWORD_MISMATCH: 'Passwords do not match.',
    MIN_LENGTH: (length) => `Must be at least ${length} characters.`,
    MAX_LENGTH: (length) => `Must be at most ${length} characters.`,
    INVALID_NUMBER: 'Please enter a valid number.',
    POSITIVE_NUMBER: 'Please enter a positive number.',
  };